import React from 'react'
import { lang, setLang } from '../../lib/i18n'

/** ไทย | EN switch (remembered per browser). */
const LangSwitch: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`inline-flex rounded-lg border border-gray-200 bg-white p-0.5 text-xs font-semibold ${className}`}>
    {(['th', 'en'] as const).map((l) => (
      <button
        key={l}
        type="button"
        onClick={() => l !== lang && setLang(l)}
        className={`px-2.5 py-1 rounded-md transition-colors ${
          lang === l ? 'bg-indigo-600 text-white' : 'text-gray-500 hover:text-gray-800'
        }`}
      >
        {l === 'th' ? 'ไทย' : 'EN'}
      </button>
    ))}
  </div>
)

export default LangSwitch
